import { Stack, Typography, useTheme } from "@mui/material";
import { SenecButton } from "src/components/button/senec-button/SenecButton";
import { ChevronRightIcon, DownloadIcon } from "src/foundations/icons";
import { SenecIconButton } from "src/components/button/senec-button/SenecIconButton";
import { CardMessages, InfoLink } from "src/components/cards/custom/data-links-card/SenecInfoLinksCard";
import { SenecBaseTheme } from "src/styles/senecBaseTheme";

export const DataLinkEntry = ({ data, messages }: { data: InfoLink; messages: CardMessages }) => {
    return (
        <Stack
            data-testid="data-link-entry"
            direction={{ xs: "column", sm: "row", md: "column", lg: "row" }}
            width="100%"
            spacing={3}
            alignContent="center"
            justifyContent="space-between"
        >
            <EntryData title={data.title} subtitle={data.subtitle} />
            <Stack
                direction="row"
                spacing={1}
                alignSelf={{ xs: "end", sm: "center", md: "end", lg: "center" }}
                justifyContent={{ xs: "center", sm: "end", md: "center", lg: "end" }}
                minWidth="130px"
            >
                {data.document && (
                    <SenecButton level="tertiary" endIcon={<DownloadIcon />} href={data.document} rel="noopener" target="_blank">
                        {messages.download}
                    </SenecButton>
                )}
                {data.website && (
                    <SenecButton
                        level="tertiary"
                        endIcon={<ChevronRightIcon />}
                        href={data.website}
                        rel="noopener"
                        target="_blank"
                    >
                        {messages.website}
                    </SenecButton>
                )}
            </Stack>
        </Stack>
    );
};

export const DataDownloadEntry = ({ data }: { data: InfoLink }) => {
    return (
        <Stack
            data-testid="data-link-entry"
            direction="row"
            width="100%"
            spacing={3}
            alignContent="center"
            justifyContent="space-between"
        >
            <EntryData title={data.title} subtitle={data.subtitle} />
            {data.document && (
                <SenecIconButton
                    data-testid={"download-icon"}
                    level="tertiary"
                    href={data.document}
                    rel="noopener"
                    target="_blank"
                >
                    <DownloadIcon />
                </SenecIconButton>
            )}
        </Stack>
    );
};

const EntryData = ({ title, subtitle }: { title: string; subtitle: string }) => {
    const theme: SenecBaseTheme = useTheme();

    return (
        <Stack spacing={0.5}>
            <Typography variant="h5" sx={{ wordBreak: "break-word" }}>
                {title}
            </Typography>
            <Typography color={theme.palette.neutralGray70.main}>{subtitle}</Typography>
        </Stack>
    );
};
